<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>Risk Matrix</strong>
        </span>
    </div>
    <div class="card-block watermark">
        <div class="row">
            <div class="col-lg-12">
                <button type="button" class="btn btn-primary btn-sm mb-3" data-target="#matrixMasterModal"
                    (click)="showGetEntityListDetails()"
                    [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/addEvaluationQuestion', 'method':'post', 'menu': 'EvaluationQuestion' }">
                    Add Matrix
                </button>
                <div class="table-responsive table-bordered margin-bottom-50">
                    <table datatable [dtOptions]="dtOptions" id="riskMatrixTable" [dtTrigger]="dtTrigger"
                        class="table table-hover compact cell-border nowrap table-striped dataTable"
                        style="background: transparent" width="100%">
                        <thead>
                            <tr>
                                <th style="width:5%">Sr. No.</th>
                                <th style="width:10%">Matrix Name</th>
                                <th style="width:65%">Risk Matrix</th>
                                <th
                                    [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/editEvaluationQuestion', 'method':'put', 'menu': 'EvaluationQuestion' }">
                                    Edit</th>
                                <th
                                    [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/deleteEvaluationQuestion', 'method':'delete', 'menu': 'EvaluationQuestion' }">
                                    Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let matrix of matrixMasterList;let count=index">
                                <td style="text-align:center;width:5%">{{count + 1}}</td>
                                <td style="width:10%">{{matrix.MatrixName}}</td>
                                <td style="width: 65%;word-wrap: break-word;white-space:normal">
                                    {{matrix.RiskMatrix}}
                                </td>
                                <td style="width: 5%;text-align: center;color: #74708d;cursor: pointer;"
                                    (click)="editQuestionDetails(matrix)"
                                    [appHasPermission]="{ 'Url': '/api/v1/secure/boardEvaluationQuestion/editEvaluationQuestion', 'method':'put', 'menu': 'EvaluationQuestion' }">
                                    <div class="fa fa-pencil"></div>
                                </td>
                                <td style="
                    width: 5%;
                    text-align: center;
                    color: #74708d;
                    cursor: pointer;
                  " data-target="#deleteQuestionMasterModal" [appHasPermission]="{
                    Url: '/api/v1/secure/boardEvaluationQuestion/deleteEvaluationQuestion',
                    method: 'delete',
                    menu: 'EvaluationQuestion'
                  }" (click)="deleteQuestionIdToPass(matrix)">
                                    <div class="fa fa-trash-o"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Modal for adding new Role-->
                <div class="modal fade" id="matrixMasterModal" tabindex="-1" role="dialog"
                    aria-labelledby="matrixMasterModalLabel">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content" style="width: 1000px; right: 50%;">
                            <div class="modal-header" style="justify-content: unset !important">
                                <h4 class="modal-title" id="matrixMasterModalLabel">
                                    Add Matrix
                                </h4>
                                <button type="button" class="close" style="right: 5px; position: absolute"
                                    data-dismiss="modal" (click)="closeForm()" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="modal-body">
                                <form [formGroup]="matrixForm">
                                    <div class="row pt-1 pb-1">
                                        <label class="col-md-4">Matrix Name: <sup style="color: red">*</sup>:</label>
                                        <div class="col-sm-8">
                                            <input placeholder="Enter Matrix Name" class="form-control"
                                                name="MatrixName" [formControl]="matrixForm.controls['matrixName']"
                                                type="text" (change)="matrixFormRiskMatrixChange($event)" />
                                        </div>
                                    </div>
                                    <div class="row pt-1 pb-1">
                                        <div class="col-lg-2">
                                            <label class="form-control-label">Risk Matrix:
                                                <span style="color: red;">*</span>
                                            </label>
                                        </div>
                                        <div class="ml-3 mt-1">
                                            <label>
                                                <input type="radio" name="numOption"
                                                    [formControl]="matrixForm.controls['selectedValue']" [value]="3"
                                                    (click)="onRiskMatrixChange($event)">
                                                3X3
                                            </label>
                                            <label class="ml-3">
                                                <input type="radio" name="numOption"
                                                    [formControl]="matrixForm.controls['selectedValue']" [value]="5"
                                                    (click)="onRiskMatrixChange1($event)">
                                                5X5
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row pt-1 pb-1">
                                        <table class="risk-matrix">
                                            <thead>
                                                <tr>
                                                    <th rowspan="2"></th>
                                                    <th colspan="{{ impactLabels.length }}" style="text-align: center;">
                                                        Impact</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2"></th>
                                                    <th *ngFor="let impact of impactLabels">{{ impact }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let prob of probabilityLabels; let i = index">
                                                    <th *ngIf="i === 0" [attr.rowspan]="probabilityLabels.length"
                                                        style="writing-mode: vertical-lr; text-align: center; vertical-align: middle;">
                                                        Probability
                                                    </th>
                                                    <td>{{ prob }}</td>
                                                    <td *ngFor="let impact of impactLabels; let j = index">
                                                        <input type="text"
                                                            [formControl]="matrixForm.get('Results').get([i]).get([j])"
                                                            class="matrix-input" placeholder="Value" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </form>
                            </div>

                            <div class="modal-footer">
                                <div style="width: 100%; text-align: left">
                                    <span style="color: #ff0000">*</span> Indicates Mandatory
                                    field
                                </div>
                                <button type="button" class="btn btn-primary btn-sm"
                                    [disabled]="!matrixForm.valid || disableSavebutton" (click)="submitMatrixDetails()">
                                    Save
                                </button>
                                <button type="button" class="btn btn-default btn-sm"
                                    style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                                    (click)="closeForm()">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editingQuestionModal" tabindex="-1" role="dialog"
                    aria-labelledby="editQuestionMasterModalLabel">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content" style="width: 1000px; right: 50%;">
                            <div class="modal-header" style="justify-content: unset !important">
                                <h4 class="modal-title" id="editQuestionMasterModalLabel">
                                    Edit Matrix
                                </h4>
                                <button type="button" class="close" style="right: 5px; position: absolute"
                                    data-dismiss="modal" (click)="closeForm()" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="modal-body">
                                <form [formGroup]="editmatrixForm">
                                    <div class="row pt-1 pb-1">
                                        <label class="col-md-4">Matrix Name: <sup style="color: red">*</sup>:</label>
                                        <div class="col-sm-8">
                                            <input placeholder="Enter Matrix Name" class="form-control"
                                                name="MatrixName" [formControl]="editmatrixForm.controls['MatrixName']"
                                                type="text" (change)="editmatrixFormRiskMatrixChange($event)" />
                                        </div>
                                    </div>
                                    <div class="row pt-1 pb-1">
                                        <div class="col-lg-2">
                                            <label class="form-control-label">Risk Matrix:
                                                <span style="color: red;">*</span>
                                            </label>
                                        </div>
                                        <div class="ml-3 mt-1">
                                            <label>
                                                <input type="radio" name="editNumOption"
                                                    [formControl]="editmatrixForm.controls['RiskMatrix']" [value]="3"
                                                    (click)="onEditRiskMatrixChange($event)">
                                                3X3
                                            </label>
                                            <label class="ml-3">
                                                <input type="radio" name="editNumOption"
                                                    [formControl]="editmatrixForm.controls['RiskMatrix']" [value]="5"
                                                    (click)="onEditRiskMatrixChange1($event)">
                                                5X5
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row pt-1 pb-1">
                                        <table class="risk-matrix">
                                            <thead>
                                                <tr>
                                                    <th rowspan="2"></th>
                                                    <th colspan="{{ impactLabels.length }}" style="text-align: center;">
                                                        Impact</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2"></th>
                                                    <th *ngFor="let impact of impactLabels">{{ impact }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let prob of probabilityLabels; let i = index">
                                                    <th *ngIf="i === 0" [attr.rowspan]="probabilityLabels.length"
                                                        style="writing-mode: vertical-lr; text-align: center; vertical-align: middle;">
                                                        Probability
                                                    </th>
                                                    <td>{{ prob }}</td>
                                                    <td *ngFor="let impact of impactLabels; let j = index">
                                                        <input type="text"
                                                            [formControl]="editmatrixForm.get('Results').get([i]).get([j])"
                                                            class="matrix-input" placeholder="Value" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <div style="width: 100%; text-align: left">
                            <span style="color: #ff0000">*</span> Indicates Mandatory
                            field
                        </div>
                        <button type="button" class="btn btn-primary btn-sm"
                            [disabled]="!editmatrixForm.valid || disableupdatebutton" (click)="udpateQuestionDetails()">
                            Update
                        </button>
                        <button type="button" class="btn btn-default btn-sm"
                            style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                            (click)="closeForm()">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="deleteQuestionMasterModal" tabindex="-1" role="dialog"
            aria-labelledby="deleteQuestionMasterModalLabel">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="justify-content: unset !important">
                        <h4 class="modal-title" id="deleteQuestionMasterModalLabel">
                            Delete Matrix
                        </h4>
                        <button type="button" class="close" style="right: 5px; position: absolute" data-dismiss="modal"
                            (click)="closeForm()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">Are you sure you want to delete ?</div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" (click)="deleteQuestionDetails()">
                            Delete
                        </button>
                        <button type="button" class="btn btn-default btn-sm"
                            style="background-color: #ffffff; color: #acb7bf !important" data-dismiss="modal"
                            (click)="closeForm()">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <app-alert></app-alert>
        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
            style="top: 50px; z-index: 9999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertPopUpTitle" class="modal-header"
                        style="font-size: 20px; font-weight: bold; padding: 5px 15px"></div>
                    <div class="modal-body" style="padding: 10px 15px">
                        <div id="alertMessage" style="font-size: 16px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
</section>